<px-m0200-bullet-list-teaser
    [image]="content.image"
    [imageTablet]="content.imageTablet"
    [imageMobile]="content.imageMobile"
    [headline]="content.headline"
    [headlineType]="content.headlineType"
    [bulletpointsChunks]="bulletpointsChunks"
></px-m0200-bullet-list-teaser>
